import { render, staticRenderFns } from "./list.vue?vue&type=template&id=286bdbb8&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bdbb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286bdbb8')) {
      api.createRecord('286bdbb8', component.options)
    } else {
      api.reload('286bdbb8', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=286bdbb8&scoped=true", function () {
      api.rerender('286bdbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/order/list.vue"
export default component.exports